import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import PdfStore from 'stores/PdfStore'
import { Checkbox } from 'react-icheck'
import './Print.css'

const FIXING = {value:'',date:''}
const FIXING1 = {value:'',name:''}
const FIXING2 = {value:'',name:''}
const FIXING3 = {value:'',price:''}
const ITEMFIXING = {
    related_detail:{
        fixing:FIXING,
        fixing1:FIXING1,
        fixing2:FIXING2,
        fixing3:FIXING3,
    }
}
class PrintORCFixingOrderDoc extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {
          loading:false,
            data:{
                car:{},
                owner:{},
                receiving:{},
                related_detail:{
                    fixing:FIXING,
                    fixing1:FIXING1,
                    fixing2:FIXING2,
                    fixing3:FIXING3,
                }
            },
            report_title:'กำลังดึงข้อมูล..'
        }

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        PdfStore.loadAnyParkingcarDoc(this.props.workNo,'orc_parking_doc',(result)=>{
            let data = result.data
            data = Object.assign(data,{related_detail:ITEMFIXING.related_detail})
            this.setState({data:data,report_title:'ไม่พบข้อมูล'})
        },()=>{
            this.setState({data:{},report_title:'ไม่พบข้อมูล'})
        })
    }

    renderLogoUrl(logoUrl){
        let imgUrl = ''
        if (process.env.NODE_ENV == "development") {
            imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
        }else{
            imgUrl = '../'+logoUrl
        }
        if(logoUrl!==undefined)
            return (<img src={imgUrl} style={{width:'40px',height:'40px'}} />)
        else
            return ('')
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    onFixingChange(value) {
        let {data} = this.state
        data.related_detail.fixing.value = value
        this.setState({data:data})
    }

    onFixingChange1(value) {
        let {data} = this.state
        data.related_detail.fixing1.value = value
        this.setState({data:data})
    }

    onFixingChange2(value) {
        let {data} = this.state
        data.related_detail.fixing2.value = value
        this.setState({data:data})
    }

    onFixingChange3(value) {
        let {data} = this.state
        data.related_detail.fixing3.value = value
        this.setState({data:data})
    }

    renderTable() {
        let {data} = this.state
        return(
            <div>
                <div className='box-no-bottom'>
                    <div className='box-header'>
                        <div className='box-title'>
                            รายละเอียดการแจ้งซ่อม
                        </div>
                        <span className='box-tools'>
                            ส่วนที่ 1
                        </span>
                    </div>
                    <div className='box-body'>
                        <table className='table table-orc-no-border'>
                            <tbody>
                                <tr>
                                    <td style={{width:'500px'}}>ชื่อทรัพย์สิน {data.car.brand} {data.car.model} {data.car.series}</td>
                                    <td style={{width:'150px'}}>รหัสทรัพย์สิน</td>
                                    <td style={{width:'150px'}}>เลขทะเบียน {data.car.car_registration_no}</td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>สถานที่ตั้ง {data.owner.addres}</td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>รายละเอียดของอาการเสีย </td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <table className='table table-orc-no-border'>
                            <tbody>
                                <tr>
                                    <td colSpan={3}>สาเหตุการเสียเพราะ </td>
                                </tr>
                                <tr>
                                    <td style={{width:'450px'}}>ผู้แจ้งซ่อม </td>
                                    <td style={{width:'150px'}}>วันที่</td>
                                    <td style={{width:'150px'}}>เวลา</td>
                                </tr>
                                <tr>
                                    <td style={{width:'450px'}}>ผู้รับแจ้งซ่อม </td>
                                    <td style={{width:'150px'}}>วันที่</td>
                                    <td style={{width:'150px'}}>เวลา</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='box-no-bottom'>
                    <div className='box-header'>
                        <div className='box-title'>
                            กำหนดการซ่อม
                        </div>
                        <span className='box-tools'>
                            ส่วนที่ 2
                        </span>
                    </div>
                    <div className='box-body'>
                        <table className='table table-orc-no-border'>
                            <tbody>
                                <tr>
                                    <td colSpan={2}>
                                        <Checkbox
                                            onChange={this.onFixingChange.bind(this,'0')}
                                            checked={data.related_detail.fixing.value==='0'?true:false}
                                            checkboxClass="icheckbox_minimal"
                                            increaseArea="20%"
                                            label={' งานเร่งด่วนให้ดำเนินการทันที'}
                                        >
                                        </Checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width:'400px'}}>
                                        <Checkbox
                                            onChange={this.onFixingChange.bind(this,'1')}
                                            checked={data.related_detail.fixing.value==='1'?true:false}
                                            checkboxClass="icheckbox_minimal"
                                            increaseArea="20%"
                                            label={' ให้ซ่อมวันที่'}
                                        >
                                        </Checkbox>
                                    </td>
                                    <td style={{width:'200px'}}>กำหนดซ่อมเสร็จวันที่</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className='box-title'>
                            ลักษณะงานของการซ่อม :
                        </div>
                        <table className='table table-orc-no-border'>
                            <tbody>
                                <tr>
                                    <td style={{width:'400px'}}>
                                        <Checkbox
                                            onChange={this.onFixingChange1.bind(this,'0')}
                                            checked={data.related_detail.fixing1.value==='0'?true:false}
                                            checkboxClass="icheckbox_minimal"
                                            increaseArea="20%"
                                            label={' ให้ดำเนินการโดยเจ้าหน้าที่ของบริษัทเอง'}
                                        >
                                        </Checkbox>
                                    </td>
                                    <td style={{width:'200px'}}>ผู้รับผิดชอบ</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Checkbox
                                            onChange={this.onFixingChange1.bind(this,'1')}
                                            checked={data.related_detail.fixing1.value==='1'?true:false}
                                            checkboxClass="icheckbox_minimal"
                                            increaseArea="20%"
                                            label={' ให้ดำเนินการโดยช่างซ่อมของบริษัทภายนอกหรือจ้างซ่อม'}
                                        >
                                        </Checkbox>
                                    </td>
                                    <td>ผู้รับผิดชอบ</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Checkbox
                                            onChange={this.onFixingChange1.bind(this,'2')}
                                            checked={data.related_detail.fixing1.value==='2'?true:false}
                                            checkboxClass="icheckbox_minimal"
                                            increaseArea="20%"
                                            label={' ให้ดำเนินการโดยช่างซ่อมของบริษัทผู้ผลิต'}
                                        >
                                        </Checkbox>
                                    </td>
                                    <td>ผู้รับผิดชอบ</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className='box-title'>
                            วิเคระห์สาเหตุ :
                        </div>
                        <div>
                            <Checkbox
                                onChange={this.onFixingChange2.bind(this,'0')}
                                checked={data.related_detail.fixing2.value==='0'?true:false}
                                checkboxClass="icheckbox_minimal"
                                increaseArea="20%"
                                label={' หมดอายุการใช้งาน'}
                            >
                            </Checkbox>  
                            {' '}  
                            <Checkbox
                                onChange={this.onFixingChange2.bind(this,'1')}
                                checked={data.related_detail.fixing2.value==='1'?true:false}
                                checkboxClass="icheckbox_minimal"
                                increaseArea="20%"
                                label={' ความประมาท'}
                            >
                            </Checkbox>  
                        </div>
                        <div>
                            <Checkbox
                                onChange={this.onFixingChange2.bind(this,'2')}
                                checked={data.related_detail.fixing2.value==='2'?true:false}
                                checkboxClass="icheckbox_minimal"
                                increaseArea="20%"
                                label={' อื่นๆ'}
                            >
                            </Checkbox>    
                        </div>   
                        <br />
                        <table className='table table-orc-no-border'>
                            <tbody>
                                <tr>
                                    <td style={{width:'50%'}}>ลงชื่อ</td>
                                    <td style={{width:'50%'}}>หัวหน้าแผนกซ่อมบำรุง/เจ้าหน้าที่ซ่อมบำรุง</td>
                                </tr>
                            </tbody>
                        </table>            
                    </div>
                </div>
                <div className='box-no-bottom'>
                    <div className='box-header'>
                        <div className='box-title'>
                            บันทึกการซ่อม
                        </div>
                        <span className='box-tools'>
                            ส่วนที่ 3
                        </span>
                    </div>
                    <div className='box-body'>
                        <table className='table table-orc-no-border'>
                            <tbody>
                                <tr>
                                    <td style={{width:'50%'}} className='text-center'>วันที่เริ่มซ่อม</td>
                                    <td style={{width:'50%'}} className='text-center'>เวลา</td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <div>
                            <div style={{display:'inline-block',width:'50%',padding:'5px'}}>
                                <div className='text-center'>รายการตรวจเช็ค</div>
                                <table className='table table-orc-border-bottom'>
                                    <tbody>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div style={{display:'inline-block',width:'50%',padding:'5px'}}>
                                <div className='text-center'>รายการการซ่อมและแก้ไข</div>
                                <table className='table table-orc-border-bottom'>
                                    <tbody>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                        <tr>
                                            <td><br /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <table className='table table-orc-no-border'>
                            <tbody>
                                <tr>
                                    <td style={{width:'50%'}}>ลงชื่อ</td>
                                    <td style={{width:'50%'}}>เจ้าหน้าที่ซ่อมบำรุง</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>     
                <div className='box-no-bottom' style={{borderBottom:'1px solid #111'}}>
                    <div className='box-header'>
                        <div className='box-title'>
                            ผลการตรวจรับงานซ่อม
                        </div>
                        <span className='box-tools'>
                            ส่วนที่ 4
                        </span>
                    </div>
                    <div className='box-body'>
                        <table className='table table-orc-no-border'>
                            <tbody>
                                <tr>
                                    <td style={{width:'500px'}} className='text-left'>
                                        <Checkbox
                                            onChange={this.onFixingChange3.bind(this,'0')}
                                            checked={data.related_detail.fixing3.value==='0'?true:false}
                                            checkboxClass="icheckbox_minimal"
                                            increaseArea="20%"
                                            label={' ต้องชดใช้'}
                                        >
                                        </Checkbox>  
                                    </td>
                                    <td style={{width:'100px'}} className='text-left'>จำนวนเงิน</td>
                                    <td style={{width:'100px'}} className='text-left'>บาท</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>
                                        <Checkbox
                                            onChange={this.onFixingChange3.bind(this,'1')}
                                            checked={data.related_detail.fixing3.value==='1'?true:false}
                                            checkboxClass="icheckbox_minimal"
                                            increaseArea="20%"
                                            label={' สามารถใช้งานได้ตามปกติ'}
                                        >
                                        </Checkbox>  
                                    </td>
                                    <td className='text-left'>ค่าใช้จ่าย</td>
                                    <td className='text-left'>บาท</td>
                                </tr>
                                <tr>
                                    <td className='text-left'>
                                        <Checkbox
                                            onChange={this.onFixingChange3.bind(this,'2')}
                                            checked={data.related_detail.fixing3.value==='2'?true:false}
                                            checkboxClass="icheckbox_minimal"
                                            increaseArea="20%"
                                            label={' ไม่สามารถใช้งานได้ตามปกติ เพราะ'}
                                        >
                                        </Checkbox>  
                                    </td>
                                    <td className='text-left'>ค่าใช้จ่ายตามใบสั่งซ่อม</td>
                                    <td className='text-left'>บาท</td>
                                </tr>
                            </tbody>
                        </table>
                        <table className='table table-orc-border-bottom'>
                            <tbody>
                                <tr>
                                    <td><br /></td>
                                </tr>
                                <tr>
                                    <td><br /></td>
                                </tr>
                            </tbody>
                        </table>  
                        <table className='table table-orc-no-border'>
                            <tbody>
                                <tr>
                                    <td style={{width:'50%'}}>ผู้ตรวจรับ</td>
                                    <td style={{width:'50%'}}>วันที่</td>
                                </tr>
                                <tr>
                                    <td>ผู้ตรวจสอบ</td>
                                    <td>วันที่</td>
                                </tr>
                            </tbody>
                        </table>      
                    </div>
                </div>                   
            </div>
        )
    }

    renderComponentPage() {
        let {data} = this.state
        return(  
            <div className='font-print print-orc'>
                <header className="text-center" style={{paddingBottom:'0'}}>
                    <h2>{this.props.title}</h2>
                </header>
                <div className='text-right'>
                    {this.renderLogoUrl(data.logo_url)}
                </div>
                <br />
                <div>
                    <div style={{display:'inline-block'}}>เลขที่ใบแจ้งซ่อม {this.props.workNo}</div>
                    <div style={{display:'inline-block',float:'right'}}>วันที่ {data.receiving.contact_date}</div>
                </div>
                {this.renderTable()}
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        return(
            <PrintPreview 
                loading={loading}
                leftBarTitle={this.props.title}
            >
                {this.renderComponentPage()}   
            </PrintPreview>
        )
        // if (dataList.length==0) {
        //     return(
        //         <PrintPreview 
        //             loading={loading}
        //             leftBarTitle={this.props.title}
        //         >
        //             {this.renderNoData()}    
        //         </PrintPreview>
        //     )
        // } else {
        //     return(
        //         <PrintPreview 
        //             loading={loading}
        //             leftBarTitle={this.props.title}
        //         >
        //             {
        //                 dataList.map((item,index)=>{
        //                     return(
        //                         this.renderComponentPage(item,index,dataList.length)
        //                     )
        //                 })   
        //             }
        //         </PrintPreview>
        //     )
        // }      
    }
}

PrintORCFixingOrderDoc.defaultProps = {
    title: 'ใบแจ้งซ่อม',
    mode: '',
    workNo: ''
  }
  export default PrintORCFixingOrderDoc;


// WEBPACK FOOTER //
// ./src/view/print/orc/PrintORCFixingOrderDoc.js